<section>
    <section
        class="drawer-modal"
        [ngClass]="{
            'drawer-modal--open': isDrawerOpen,
            'drawer-modal--full-screen': isFullScreen,
            'drawer-modal--not-full-screen': !isFullScreen,
            'drawer-modal--minimized': isMinimized
        }"
    >
        <div
            *ngIf="isDraggable"
            class="drag-overlay"
            (mousedown)="onHandleMouseDown($event)"
            (touchstart)="onHandleTouchStart($event)"
            (keydown)="onHandleKeyDown($event)"
            role="button"
            tabindex="0"
            aria-label="Drag to resize drawer"
        ></div>
        <div
            #drawerHandle
            class="drawer-handle"
            *ngIf="isDraggable"
            role="button"
            tabindex="0"
            aria-label="Drawer handle"
            (keydown)="onHandleKeyDown($event)"
            (keyup)="expandDrawer()"
        >
        <div class="handle-line"></div>
        </div>
        <div
            class="close-button"
            (click)="onOutsideClick.emit(); forceResetOverflow()"
            (keydown)="onOutsideClick.emit(); forceResetOverflow()"
            (keyup)="onOutsideClick.emit(); forceResetOverflow()"
            *ngIf="showCloseIcon"
        >
            <img
                src="/img/icons/xmark-circle.svg"
                alt="CloseButton"
                height="20"
                width="20"
            />
        </div>
        <ng-content></ng-content>
    </section>
    <div
        [ngClass]="{ 'drawer-overlay': isDrawerOpen }"
        (click)="onOutsideClick.emit(); forceResetOverflow()"
        (keydown)="onOutsideClick.emit(); forceResetOverflow()"
        (keyup)="onOutsideClick.emit(); forceResetOverflow()"
    ></div>
</section>
